import { RootState } from "../store";
import { LayoutState } from "../slices/layout/layout.slice.ts";
import { LoanState } from "../slices/loan/loan.slice.ts";
import { CustomerState } from "../slices/customer/customer.slice.ts";
import { SessionState } from "../slices/session/session.slice.ts";

export const selectRoot = (state: RootState) => state;
export const selectCustomer = (state: RootState) =>
  state.customer as CustomerState;
export const selectLoan = (state: RootState) => state.loan as LoanState;
export const selectLayout = (state: RootState) => state.layout as LayoutState;
export const selectSession = (state: RootState) =>
  state.session as SessionState;
export const selectCurrentState = (state: RootState) => state.session.state;
